const ERROR_KEY = {
  NETWORK: 'ERR_NETWORK',
  TEMP_PASSWORD_EXPIRED: 'temp_password_expired'
}

export default ERROR_KEY
